var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _vm.rm
                ? _c("div", [
                    _c("p", [
                      _vm._v(
                        "\n                Please note that the Portfolio Planning feature is currently in its beta phase and is not enabled on this portfolio.\n                We are actively working on refining this tool to ensure it meets our high standards of performance and user experience.\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n                If you're interested in exploring the Portfolio Planning feature and would like to request beta access, we encourage you to contact us.\n                We value your interest and are eager to involve our users in the development process. By contacting us, you can gain early access and provide valuable feedback to help shape this feature.\n                We are more than happy to provide detailed information and updates, and we look forward to hearing from you.\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Thank you for your understanding and support as we continue to enhance our services."
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-6" }, [
        _c(
          "h1",
          {
            staticStyle: {
              "font-size": "2em",
              "font-weight": "300",
              color: "#33475b",
              margin: "0",
            },
          },
          [_vm._v("Portfolio Planning - Beta Version")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6 text-right align-self-end" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }